import { GridColDef, GridColumns, GridRenderCellParams } from '@mui/x-data-grid-premium';
import { filterOperators } from '../../../../constants';
import { useTranslation } from 'react-i18next';
import { baseCell } from '../cells/base-cell';
import SectionTitle from 'components/common/SectionTitle';
import { Link } from 'react-router-dom';
import { MODELS_MAPS } from 'components/common/HistoryList/versions/Versions';

export function DeletedVersionsColumns(): GridColDef[] {
  const { t } = useTranslation();
  const columns: GridColumns = [
    {
      field: 'object_id',
      headerName: t(`global.object`),
      width: 200,
      renderCell: (params) => {
        return (
          <Link
            to={`/tenant/versions/${params.row.model_name}/${params.row.object_id}`}
            style={{ textDecoration: 'none', color: '#1976d2' }}>
            <SectionTitle>{params.row.object_id}</SectionTitle>
          </Link>
        );
      }
    },
    {
      field: 'object_value',
      headerName: t(`global.value`),
      filterOperators,
      width: 200,
      renderCell: baseCell
    },
    {
      field: 'model_name',
      headerName: t(`global.model`),
      filterOperators,
      width: 200,
      renderCell: (params) => {
        const modelKey = params.value;
        return MODELS_MAPS[modelKey]?.label || modelKey; // fallback se non trova la label
      }
    },
    {
      field: 'timestamp',
      headerName: t(`global.date`),
      filterOperators,
      width: 200,
      renderCell: (params: GridRenderCellParams) => {
        const date = new Date(params.value as string);
        return date.toLocaleString('default', {
          year: 'numeric',
          month: '2-digit',
          day: '2-digit',
          hour: '2-digit',
          minute: '2-digit'
        });
      }
    },
    {
      field: 'actor_name',
      headerName: t(`global.user`),
      filterOperators,
      width: 200,
      renderCell: (params) => {
        const value = params.value;
        return value == null ? 'SYSTEM' : baseCell(params);
      }
    }
  ];
  return columns;
}
